import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=fa5ba490&scoped=true&lang=pug&"
import script from "./Prompt.vue?vue&type=script&lang=js&"
export * from "./Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=fa5ba490&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5ba490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog})
